(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function trackRecentlyViewed(handle, limit) {
    if (!handle) return;
    var key = 'bhi:recently_viewed';
    var stored = [];
    try {
      stored = JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (e) {
      stored = [];
    }
    stored = stored.filter(function (item) {
      return item !== handle;
    });
    stored.unshift(handle);
    if (limit && stored.length > limit) {
      stored = stored.slice(0, limit);
    }
    try {
      window.localStorage.setItem(key, JSON.stringify(stored));
    } catch (e) {
      return;
    }
  }

  function setupGallery(section) {
    var mainImage = section.querySelector('[data-bhi-main-image]');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-bhi-thumb]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-bhi-dot]'));
    if (!mainImage || thumbs.length === 0) return;

    function selectIndex(index) {
      var selected = thumbs[index];
      if (!selected) return;
      var full = selected.getAttribute('data-full');
      var alt = selected.getAttribute('data-alt') || '';
      if (full) {
        mainImage.setAttribute('src', full);
      }
      mainImage.setAttribute('alt', alt);
      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === index);
      });
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === index);
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        selectIndex(index);
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        selectIndex(index);
      });
    });

    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });
    selectIndex(activeIndex === -1 ? 0 : activeIndex);
  }

  function setupVariantSelection(section) {
    var variantsJson = section.querySelector('[data-bhi-variants-json]');
    if (!variantsJson) return;
    var variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent || '[]');
    } catch (e) {
      variants = [];
    }

    var hiddenInput = section.querySelector('[data-bhi-variant-id]');
    var skuTarget = section.querySelector('[data-bhi-sku]');
    var addButton = section.querySelector('[data-bhi-atc]');
    var variantInputs = Array.prototype.slice.call(section.querySelectorAll('[data-bhi-variant-input]'));
    if (variantInputs.length === 0 || !hiddenInput) return;

    function setActiveCard(selectedInput) {
      variantInputs.forEach(function (input) {
        var card = input.closest('[data-bhi-variant-card]');
        if (card) {
          card.classList.toggle('is-active', input === selectedInput);
        }
      });
    }

    function updateForVariant(variantId, inputEl) {
      var variant = variants.find(function (item) {
        return String(item.id) === String(variantId);
      });
      if (!variant) return;
      hiddenInput.value = variant.id;
      if (skuTarget) {
        skuTarget.textContent = variant.sku || '';
      }
      if (addButton && inputEl) {
        var isAvailable = inputEl.getAttribute('data-available') === 'true';
        var isSelectable = inputEl.getAttribute('data-selectable') !== 'false';
        addButton.disabled = !(isAvailable && isSelectable);
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setActiveCard(input);
        updateForVariant(input.value, input);
      });
    });

    var selected = variantInputs.find(function (input) {
      return input.checked;
    }) || variantInputs[0];
    if (selected) {
      setActiveCard(selected);
      updateForVariant(selected.value, selected);
    }
  }

  function setupQtyStepper(section) {
    var dec = section.querySelector('[data-bhi-qty-decrease]');
    var inc = section.querySelector('[data-bhi-qty-increase]');
    var input = section.querySelector('[data-bhi-qty-input]');
    if (!dec || !inc || !input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);

    function clamp(value) {
      return Math.max(min, value);
    }

    dec.addEventListener('click', function () {
      var current = parseInt(input.value || '1', 10);
      input.value = clamp(current - 1);
      input.dispatchEvent(new Event('change'));
    });

    inc.addEventListener('click', function () {
      var current = parseInt(input.value || '1', 10);
      input.value = clamp(current + 1);
      input.dispatchEvent(new Event('change'));
    });
  }

  function setupTabs(section) {
    var tabLinks = Array.prototype.slice.call(section.querySelectorAll('[data-bhi-tab-link]'));
    if (tabLinks.length === 0) return;
    var targets = tabLinks
      .map(function (link) {
        var id = link.getAttribute('href');
        if (!id) return null;
        return document.querySelector(id);
      })
      .filter(Boolean);

    function setActiveById(id) {
      tabLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('href') === id);
      });
    }

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        setActiveById(link.getAttribute('href'));
      });
    });

    if ('IntersectionObserver' in window && targets.length > 0) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActiveById('#' + entry.target.id);
            }
          });
        },
        { rootMargin: '-40% 0px -50% 0px', threshold: 0.2 }
      );
      targets.forEach(function (target) {
        observer.observe(target);
      });
    }
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findMarkerBlock(root, label) {
    var normalizedLabel = normalizeText(label);
    var marker = null;

    Array.prototype.slice.call(root.querySelectorAll('*')).forEach(function (element) {
      if (!element.tagName) return;
      if (
        ['TABLE', 'TBODY', 'THEAD', 'TFOOT', 'TR', 'TD', 'TH', 'COLGROUP', 'COL'].indexOf(element.tagName) !== -1
      ) {
        return;
      }
      if (normalizeText(element.textContent) !== normalizedLabel) return;
      marker = element;
    });

    if (!marker) return null;

    while (
      marker.parentElement &&
      marker.parentElement !== root &&
      normalizeText(marker.parentElement.textContent) === normalizedLabel
    ) {
      marker = marker.parentElement;
    }

    return marker;
  }

  function cloneRange(root, startAfterNode, endBeforeNode) {
    var range = root.ownerDocument.createRange();
    if (startAfterNode) {
      range.setStartAfter(startAfterNode);
    } else {
      range.setStart(root, 0);
    }
    if (endBeforeNode) {
      range.setEndBefore(endBeforeNode);
    } else {
      range.setEnd(root, root.childNodes.length);
    }

    var container = root.ownerDocument.createElement('div');
    container.appendChild(range.cloneContents());
    return container;
  }

  function hasMeaningfulContent(container) {
    if (normalizeText(container.textContent)) return true;
    return Boolean(container.querySelector('table, img, svg, video, iframe, ul, ol, dl'));
  }

  function setupDescriptionSections(section) {
    var sourceTemplate = section.querySelector('[data-bhi-description-source]');
    if (!sourceTemplate) return;

    var shouldParseDescription = section.getAttribute('data-bhi-parse-description') === 'true';
    var shouldParseSpecifications = section.getAttribute('data-bhi-parse-specifications') === 'true';
    if (!shouldParseDescription && !shouldParseSpecifications) return;

    var descriptionTarget = section.querySelector('[data-bhi-description-content]');
    var specificationsTarget = section.querySelector('[data-bhi-specifications-content]');
    var specificationsFallback = section.querySelector('[data-bhi-specifications-fallback]');
    var root = document.createElement('div');

    root.innerHTML = sourceTemplate.innerHTML.trim();

    var descriptionMarker = findMarkerBlock(root, 'Product Description');
    var specificationsMarker = findMarkerBlock(root, 'Specifications');
    var hasMarkers = Boolean(descriptionMarker || specificationsMarker);
    if (!hasMarkers) return;

    if (shouldParseDescription && descriptionTarget) {
      var descriptionContent = cloneRange(root, descriptionMarker, specificationsMarker);
      if (hasMeaningfulContent(descriptionContent)) {
        descriptionTarget.innerHTML = descriptionContent.innerHTML.trim();
      }
    }

    if (shouldParseSpecifications && specificationsTarget && specificationsMarker) {
      var specificationsContent = cloneRange(root, specificationsMarker, null);
      if (hasMeaningfulContent(specificationsContent)) {
        specificationsTarget.innerHTML = specificationsContent.innerHTML.trim();
        specificationsTarget.hidden = false;
        if (specificationsFallback) {
          specificationsFallback.hidden = true;
        }
      }
    }
  }

  function setupCallForInfo(section) {
    var triggers = section.querySelectorAll('[data-bhi-contact-info]');
    if (!triggers.length) return;
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }


  onReady(function () {
    document.querySelectorAll('[data-bhi-product]').forEach(function (section) {
      setupGallery(section);
      setupVariantSelection(section);
      setupQtyStepper(section);
      setupTabs(section);
      setupDescriptionSections(section);
      setupCallForInfo(section);
      trackRecentlyViewed(section.getAttribute('data-product-handle'), 12);
    });
  });
})();
